import React from 'react'
import { createRoot } from 'react-dom/client'
import ReactRailsUJS from 'react_ujs'
import './rails_ujs'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from 'components/api/queryClient'
import { FeatureContext } from 'components/FeatureContext'

export const componentLoadPathContextFactory = (components) => {
  return (fileToImport) => components[fileToImport.replace(/^\.\//, '')]
}

export const withFeatureFlag = (element, props) => {
  // Get feature flags from props or default to empty object
  const featureFlags = props?.featureFlags || {}

  return React.createElement(
    FeatureContext.Provider,
    { value: featureFlags },
    element
  )
}

export const withQueryClient = (element) => {
  const children = [element]

  // Only show Devtools in development (avoid in test)
  if (process.env.NODE_ENV === 'development') {
    children.push(
      React.createElement(ReactQueryDevtools, {
        initialIsOpen: false,
        panelPosition: 'bottom-right'
      })
    )
  }

  return React.createElement(QueryClientProvider, { client: queryClient }, ...children)
}

export const mount = (components) => {
  const componentLoadPathContext = componentLoadPathContextFactory(components)
  ReactRailsUJS.useContext(componentLoadPathContext)
  ReactRailsUJS.mountComponents = () => {
    document.querySelectorAll('[data-react-class]').forEach((node) => {
      const klass = ReactRailsUJS.getConstructor(node.getAttribute('data-react-class'))
      const propsWithFeatureFlag = JSON.parse(node.getAttribute('data-react-props'))
      const { featureFlags, ...props } = propsWithFeatureFlag
      const root = createRoot(node)
      const element = React.createElement(klass, props)
      root.render(
        withFeatureFlag(
          withQueryClient(element),
          { featureFlags }
        )
      )
    })
  }
}
